// this file is automatically generated by git.version.ts script
export const versions = {
	version: 'v0.6',
	revision: '7db3c1d',
	branch: 'HEAD'
};